// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import restrictedProduct from "@hardwoods/App/Handlers/RestrictedProduct/RestrictedProduct";
import { addToChainAfter, addToChainBefore, makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import { chain, NavigateToReturnUrl, PopulateApiParameter } from "@insite/client-framework/Store/Context/Handlers/ChangeCustomerContext";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";

type HandlerType = Parameters<typeof PopulateApiParameter>[0];

export const ExtendApiParameter = (props: HandlerType) => {
    if (getCurrentPage(props.getState()).type === "ChangeCustomerPage") {
        const properties = (props.apiParameter as any).session.properties
            ? (props.apiParameter as any).session.properties
            : {};
        (props.apiParameter as any).session.properties = {
            ...properties,
            isChangeCustomerPage: true,
        };
    }
};

export const NavigateForRestrictedProduct = async (props: any) => {
    const homePageUrl = getPageLinkByPageType(props.getState(), "HomePage")?.url || "/";
    const { returnUrl } = props.parameter;

    if (returnUrl && (returnUrl.includes("Catalog") || returnUrl.includes("Product"))) {
        const returnUrlArray = returnUrl.split("/");
        const erpNumber = returnUrlArray[returnUrlArray.length - 1];

        const isRestrictedProduct = await makeHandlerChainAwaitable(restrictedProduct)({
            erpNumber,
        })(props.dispatch, props.getState);

        if (isRestrictedProduct) {
            props.parameter.returnUrl = `${homePageUrl}?isRestricted=true` ;
        }
    }
};

addToChainBefore(chain, NavigateToReturnUrl, NavigateForRestrictedProduct);
addToChainAfter(chain, PopulateApiParameter, ExtendApiParameter);
